/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Вид для телефона, зависящего от города
   */
  app.CommonCityPhoneView = app.View.extend({
    /**
     * @inheritDoc
     */
    run: function () {
      this.listenTo(this.settlement, 'change', this.renderPhone);
    },
    /**
     * Меняем телефон в зависимости от выбранного города.
     * @param settlement
     */
    renderPhone: function (settlement) {
      this.$el.html(settlement.get('phone'));
    }
  });
  
})();

}.call(window));